const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://bgoavxlatg.execute-api.ap-southeast-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://rvbw19srh1.execute-api.ap-southeast-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://89osel4l1d.execute-api.ap-southeast-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.nsr.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.nsr.forwoodsafety.com',
    WEBSOCKET: 'wss://31o1517wr7.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
};

export default config;